export default __webpack_public_path__ + "static/media/bg-ring-1.50489d3f.png";